import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationGaugePressure,
    CalibrationPressureUnit
} from 'services/equipmentSets/types';
import { makeSelectCalibrationValue } from 'services/equipmentSets/selectors';
import { formatPressureUnit } from 'services/equipmentSets/utils';

import { SprayEquipmentSetId } from 'services/sprayEvents/types';

export interface OwnProps {
    calibrationId: CalibrationId;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    pressure: CalibrationGaugePressure;
    pressureUnit: CalibrationPressureUnit;
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsPressureListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pressure, pressureUnit } = this.props;
        const formattedPressureUnit = formatPressureUnit(pressureUnit);

        return (
            <ListItem
                description="Pressure"
                value={`${pressure}${
                    formattedPressureUnit && ` ${formattedPressureUnit}`
                }`}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    pressure: makeSelectCalibrationValue('gaugePressure'),
    pressureUnit: makeSelectCalibrationValue('pressureUnit')
});

export default connect(mapStateToProps)(
    SummaryCalibrationsPressureListItemComponent
);
